import CX from 'classnames'
import React from 'react'
import CursorPaginatedTable from './CursorPaginatedTable'
import { CheckboxTable } from '../../../components/CheckboxTable'
import config from '../../../config'

export default props => (
  <div
    className={CX({
      // Make first or second column sticky depending on if the first column is the checkbox
      'listing-manager-table': props.onExpandedChange,
      'listing-manager-table-sticky-first': !props.onExpandedChange
    })}
  >
    {config.CURSOR_PAGINATED_LISTING_MANAGER() ? (
      <CursorPaginatedTable
        {...props}
        pageSizeOptions={[10, 15, 30, 50, 100]}
        noDataText="No Listings Found"
        getNoDataProps={() => ({ style: { color: 'black' } })}
      />
    ) : (
      <CheckboxTable
        {...props}
        pageSizeOptions={[10, 15, 30, 50, 100]}
        noDataText="No Listings Found"
        getNoDataProps={() => ({ style: { color: 'black' } })}
      />
    )}
  </div>
)
